import ProductCardContainer from './ProductCardContainer';
export default ProductCardContainer;